import { signalStore, withState } from '@ngrx/signals';
import { withEntities } from '@ngrx/signals/entities';

import { Modalité } from '../models/modalité.model';
import { avecMéthodesModalités } from './modalité.methods';
import { withPagination } from '@shared/store/pagination.feature';
import { initialState, ModaliteState } from './modalités.state';

export const ModalitéStore = signalStore(
  { providedIn: 'root' },
  withState<ModaliteState>(initialState),
  withEntities<Modalité>(),
  avecMéthodesModalités(),
  withPagination<Modalité>(),
);
